import { useQuery } from '@tanstack/react-query';

import { programsApi } from '../api/programsApi';
import { DetailsOption, GenderOptions } from '../types/program';
import { formatDetailsOptions } from '../utils/formatDetailsOptions';

const DEFAULT_OPTIONS = {
  categories: [] as DetailsOption<number>[],
  levels: [] as DetailsOption<number>[],
  objectives: [] as DetailsOption<number>[],
  modalities: [] as DetailsOption<number>[],
  tags: [] as DetailsOption<number>[],
  gender: [] as DetailsOption<string>[],
  durationProgram: [] as DetailsOption<string>[],
  forMothers: [] as string[],
  accessory: [] as DetailsOption<boolean>[],
  showInSearch: [] as DetailsOption<boolean>[],
  isRecommendQuiz: [] as DetailsOption<boolean>[],
};

const getConfigurationStepInputsOptions = async () => {
  const configurationStepInputs =
    await programsApi.fetchConfigurationStepInputs();

  const durationProgramsOptions = ['Até 15 min', '16 - 25 min', '+26 min'];

  const forMothersOptions = [
    'Não',
    'Filhos até 5 anos',
    'Filhos acima de 5 anos',
    'Todos',
  ];

  const genderOptions = [
    { value: GenderOptions.Female, label: 'Feminino' },
    { value: GenderOptions.Male, label: 'Masculino' },
    { value: GenderOptions.Neutral, label: 'Neutro' },
  ];

  const accessoryOptions = [
    { value: true, label: 'Com acessórios' },
    { value: false, label: 'Sem acessórios' },
  ];

  const yesOrNoOptions = [
    { value: true, label: 'Sim' },
    { value: false, label: 'Não' },
  ];

  // Remove duplicate tags by label before formatting
  const uniqueTags = [...new Set(configurationStepInputs.availableTags)];

  return {
    categories: formatDetailsOptions(
      configurationStepInputs.availableCategories
    ),
    levels: formatDetailsOptions(configurationStepInputs.availableLevels),
    objectives: formatDetailsOptions(
      configurationStepInputs.availableObjectives
    ),
    modalities: formatDetailsOptions(
      configurationStepInputs.availableModalities
    ),
    tags: formatDetailsOptions(uniqueTags),
    gender: genderOptions,
    durationProgram: formatDetailsOptions(durationProgramsOptions),
    forMothers: formatDetailsOptions(forMothersOptions),
    accessory: accessoryOptions,
    showInSearch: yesOrNoOptions,
    isRecommendQuiz: yesOrNoOptions,
  };
};

export const useConfigurationStepOptions = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['configuration-step-options'],
    queryFn: getConfigurationStepInputsOptions,
    refetchOnWindowFocus: false,
  });

  return {
    configurationStepOptions: data || DEFAULT_OPTIONS,
    loadingOptions: isLoading,
  };
};
